import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import { navPaths } from "../../constants/navbar.constants";

const FriendsPage = lazy(() => import("./Pages/Friends"));
const FarmerPage = lazy(() => import("./Pages/Farmer"));

export const friendsRoute: RouteObject = {
  // path: navPaths.FRIENDS,
  // children: [{ path: "", Component: FriendsPage }],

  path: "",
  children: [
    { path: navPaths.FRIENDS, Component: FriendsPage },
    { path: navPaths.FARMER, Component: FarmerPage },
  ],
};
